import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { MiraieService } from './miraie.service';

import { Observable, of } from 'rxjs';
import { map, filter, reduce } from 'rxjs/operators';

import { Progress } from '../search-data/searchdata';
import { Ranks } from '../search-data/searchdata';
import { Staffs } from '../search-data/searchdata';
import { Plans } from '../search-data/searchdata';
import { Question } from '../search-data/searchdata';

import { ResultData } from '../search-data/searchdata';

import { PROGRESS } from '../search-data/mock-Data';
import { RANKS } from '../search-data/mock-Data';
import { STAFFS } from '../search-data/mock-Data';
import { PLANS } from '../search-data/mock-Data';
import { QUESTION } from '../search-data/mock-Data';

import { RESULTDATA } from '../search-data/mock-Data';

@Injectable({
  providedIn: 'root'
})
export class SearchService {
  ClientData: ResultData[] = RESULTDATA;

  constructor(
    private http: MiraieService,
  ) { }

  getProgress(): Progress[] {
    return PROGRESS;
  }

  getRanks(): Ranks[] {
    return RANKS;
  }

  getStaffs(): Staffs[] {
    return STAFFS;
  }

  getPlans(): Plans[] {
    return PLANS;
  }

  getQuestion(): Question[] {
    return QUESTION;
  }

  getSearchData(serch_conditions) {
    var url = "customer-search";

    let param = { serch_conditions };

    return this.http.post(url, param).pipe(
      map(res => {
        return res;
      })
    );
  }

  getResultData(entry: ResultData): ResultData[] {
    let result: ResultData[] = [];

    for (let client of this.ClientData) {
      if (client.client == entry.client)
        result.push(client);
    }

    return result;
  }
  getCustomerSchedule(login_user, status = null, condition = null) {
    var url = "customer-schedule";

    let param = { directer_code: login_user, status: { condition: condition, value: status } };

    return this.http.post(url, param);
  }
  
}
